import { Auth } from "./../auth.js"

//ユーザー設定操作
export class UserController {
    constructor(apiRootPath){
        apiRootPath ??= window.Setting.api
        this.url = apiRootPath + "user" 
    }
    /** GET user/list */
    async list(){
        let res = await Auth.ajax({
            url: `${this.url}/list`,
        })
        if(res.ok){
            res.data = JSON.parse(res.body)
        }
        return res
    }
    /**
     * POST
     * user/password
     * @param {string} oldPassword
     * @param {string} newPassword
     */
    async resetPassword(oldPassword, newPassword){
        let res = await Auth.ajax({
            url: `${this.url}/password`,
            method: "POST",
            body: {
                oldPassword,
                newPassword,
            }
        })
        return res
    }
    /** POST user/create */
     async create(data){
        let res = await Auth.ajax({
            method: "POST",
            url: `${this.url}/create`,
            body: data,
        })
        return res
    }
    /** DELETE :userId */
     async delete(id){
        let res = await Auth.ajax({
            method: "DELETE",
            url: `${this.url}/${id}`,
        })
        return res
    }
    /** PATCH :userId */
     async update(id, data){
        let res = await Auth.ajax({
            method: "PATCH",
            url: `${this.url}/${id}`,
            body: data
        })
        return res
    }
    async testOnetime(key, offset, input){
        let res = await Auth.ajax({
            method: "POST",
            url: `${this.url}/onetime/test`,
            body: { key, offset, input }
        })
        return res
    }
}